(function () {
    angular
      .module('kareo.ui.shared.directives.k-enrl-phase-3-selected-payers', [
        'kareo.ui.shared.directives.K-enrl-selected-payer-enrollments',
        'kareo.ui.shared.modules.data',
        'kareo.ui.shared.modules.featureSet'
      ])
      .directive('kEnrlPhase3SelectedPayers', kEnrlPhase3SelectedPayers)
      .directive('kWarningIndicator', kWarningIndicator);
  
    function kEnrlPhase3SelectedPayers() {
      const directive = {
        bindToController: true,
        controller,
        controllerAs: 'vm',
        scope: {
          payers: '=',
          hideEnrollment: '=',
          addedPayers: '<?',
          removePayerCallback: '&'
        },
        template: require('./k-enrl-phase-3-selected-payers.pug')()
      };
  
      return directive;
    }
  
    //--------------------------------------
    controller.$inject = ['featureSet', 'practice'];
    function controller(featureSet, practice) {
      const vm = this;
      vm.isPhase2Feature = false;
  
      init();
  
      vm.removeItem = removeItem;
  
      function init() {
        featureSet.load().then((features) => {
          vm.isInsuranceAdmin = features['dark-feature.converged-insurance-admin'];
          vm.isPhase2Feature = features['dark-feature.enrollments-upgrade-phase2']
                            || features['dark-feature.enrollments-upgrade-phase3'];
          vm.isAddInsuranceFeatureEnabled = features['dark-feature.enrollments-add-insurance'];
        });
        practice.get().then((result) => {
          vm.isPmEnabled = result.pmenabled;
        });
      }
  
      function removeItem($index, item) {
        vm.payers.splice($index, 1);
          if (vm.hideEnrollment) {
              unMarkDuplicatePayers(vm.payers);
          }
        vm.removePayerCallback({ 'payer': item });
      }
  
      function unMarkDuplicatePayers(payers) {
        payers.forEach((eachPayer) => {
          eachPayer.isDuplicate = duplicatePayerCheck(eachPayer);
        });
      }
      
      function duplicatePayerCheck(payer) {
        let checkCounter = 0;
        let check = false;
          const newPayers = vm.addedPayers.concat(vm.payers);
          for (let pi = 0; pi < newPayers.length; pi++) {
            const eachPayer = newPayers[pi];
            if (eachPayer.name === payer.name) {
              checkCounter++;
              if (checkCounter > 1) {
                check = true;
                break;
              }
          }
        }
        return check;
      }
    }
  
    function kWarningIndicator() {
      const directive = {
        template: `<i class='ki attention-alt warning-text'
                    ng-show='isVisible'
                    ng-mouseover='isTooltipVisible = true'
                    ng-mouseleave='isTooltipVisible = false'></i>
                    <span class='custom-tooltip'
                    ng-show='isTooltipVisible'
                    ng-bind='customTitle'></span>`,
        restrict: 'E',
        scope: {
          isVisible: '<',
          customTitle: '<'
        }
      };
  
      return directive;
    }
  })();
  